import React from 'react'
import Fade from 'react-reveal'

import { StyledHome } from './Home.style'
// import "../assets/style/home.css"

import Card1 from "../assets/images/card1.png"
import CardImg1 from "../assets/images/card-img1.png"
import Card2 from "../assets/images/card2.png"
import CardImg2 from "../assets/images/card-img2.png"
import Card3 from "../assets/images/card3.png"
import CardImg3 from "../assets/images/card-img3.png"
import Card4 from "../assets/images/card4.png"
import CardImg4 from "../assets/images/card-img4.png"
import TelPhone from '../assets/icons/TelPhone'
import Mobilephone from '../assets/icons/Mobilephone'

import VideoImg from "../../../assets/images/home.mp4"


export default function Home() {
  return (
    <StyledHome>
      <header className='header'>
        <div className='shadow'></div>
        <video className='main-video' src={VideoImg} autoPlay loop muted ></video>
        <div className='container'>
          <div className='main-info'>
            <h1>
              SFELDINC ensures FMCSA compliance and delivers superior
              safety and productivity for any fleet
            </h1>
            <p>The most easy-to-use ELD device and application</p>

             <a target="_blank"  href='https://portal.sfeldinc.com/service-login'>GET STARTED</a>
          </div>
        </div>
        {/* <div className='chat-wrapper'>
          <a href='https://t.me/sfeld_24' className='chat' >
            <Chatting />
          </a >
        </div> */}
      </header>


      <section>
        <div className='container '>
          <div className='section-one'>
            <div className='left'>
              <Fade left>
                <div className='card'>
                  <div className='card-img'>
                    <img src={Card1} alt='card1' />
                    <img src={CardImg1} className="second-img" alt='card-img1' />
                  </div>
                  <div className='card-info'>
                    <TelPhone />
                    <h3>Driver app on Android Devices </h3>
                    <p>Right measurement of the fleet help you set up precise business. Our "Driver App" provides a most comprehensive solutions to the market.</p>
                  </div>
                </div>
              </Fade>

              <Fade left>
                <div className='card'>
                  <div className='card-img'>
                    <img src={Card2} alt='card2' />
                    <img src={CardImg2} className="second-img" alt='card-img2' />
                  </div>
                  <div className='card-info'>
                    <Mobilephone />
                    <h3>Chat on drivers and dispatchers</h3>
                    <p>We understand the importance of approaching each work integrally and believe in the power of simple and easy communication.</p>
                  </div>
                </div>
              </Fade>
            </div>

            <div className='right'>
              <Fade right>
                <div className='card'>
                  <div className='card-img'>
                    <img src={Card3} alt='card3' />
                    <img src={CardImg3} className="second-img" alt='card-img3' />
                  </div>
                  <div className='card-info'>
                    <Mobilephone />
                    <h3>Flexible Dispatch Board</h3>
                    <p>Dispatch Board is the go-to dispatching software - created with carrier needs in mind. Dispatch Board will streamline day-to-day operations maximizing your time so you can focus on better loads and bigger profit.</p>
                  </div>
                </div>
              </Fade>
              <Fade right>
                <div className='card'>
                  <div className='card-img'>
                    <img src={Card4} alt='card4' />
                    <img src={CardImg4} className="second-img" alt='card-img4' />
                  </div>
                  <div className='card-info'>
                    <TelPhone />
                    <h3>GPS Tracking</h3>
                    <p>Keep up with demand - dispatch and track your fleet with real-time GPS, leveraging weather and traffic data to exceed your customers' expectations.</p>
                  </div>
                </div>
              </Fade>

            </div>
          </div>
        </div>
      </section>

    </StyledHome>
  )
}
